<template>
  <div class="rust-contract-detail">
    <common-bg-plate>
      <detail-table :title="title" :table-col="tableCol" :list="list"></detail-table>
      <detail-section title="合约关联任务">
        <template #actions>
          <btn-style :btn-list="btnList"></btn-style>
        </template>
        <rust-task-list ref="taskList" :contract-id="this.$route.query.contractId" @goDetail="onGoTaskDetail"
          @popConfirmRestart="onPopConfirmRestart"></rust-task-list>
      </detail-section>
    </common-bg-plate>
    <restart-rust-detector-task :task-info="taskInfo" :dialog-visible.sync="showRestartRustDetectorTask"
      @restartSuccess="onRestartTaskSuccess"></restart-rust-detector-task>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import rustTaskList from './components/rustTaskList'
import restartRustDetectorTask from './restartRustDetectorTask'
import idIconImg from '@/assets/images/tableIcon/id-icon.png'
import nameImg from '@/assets/images/tableIcon/contract-name.png'
import timeImg from '@/assets/images/tableIcon/time.png'
import addTimeImg from '@/assets/images/tableIcon/n-clock-add.png'
import checkTimeImg from '@/assets/images/tableIcon/n-clock-check.png'
import taskImg from '@/assets/images/tableIcon/n-task.png'

export default {
  name: 'RustContractDetail',
  components: {
    rustTaskList,
    restartRustDetectorTask
  },
  data() {
    return {
      title: '合约基本信息',
      tableCol: [
        { label: '合约ID', icon: idIconImg, value: 'ID' },
        { label: '合约名', icon: nameImg, value: 'Filename' },
        { label: '关联任务数', icon: taskImg, value: 'TaskCount' },
        { label: '创建时间', icon: addTimeImg, value: 'CreatedAt', formatter: this.formatTime },
        { label: '更新时间', icon: checkTimeImg, value: 'UpdatedAt', formatter: this.formatTime }
      ],
      list: {
        ID: '',
        Filename: '',
        TaskCount: 0,
        CreatedAt: 0,
        UpdatedAt: 0
      },
      showRestartRustDetectorTask: false,
      taskInfo: {
        ID: '',
        ContractID: '',
        ContractFilename: '',
        Status: 0,
        CreatedAt: 0,
        StartedAt: 0,
        FinishedAt: 0
      },
      btnList: [
        {
          btnContent: '刷新',
          click: () => {
            return this.getTaskList()
          },
          icon: 'icon-refresh',
          type: 'default'
        }
      ]
    }
  },
  mounted() {
    this.getContractInfo()
    this.getTaskList()
  },
  methods: {
    ...mapActions([]),
    getContractInfo() {
      let self = this
      this.$apis.contractdetector
        .getRustContractInfo({
          contract_id: self.$route.query.contractId
        })
        .then(res => {
          if (res && res.data && res.code === 1) {
            self.list = res.data
          }
          // console.log(res)
        })
    },
    getTaskList() {
      this.$refs.taskList.refresh(this.$route.query.contractId)
    },
    formatTime(data, value) {
      let time = data[value]
      if (time) {
        return this.$utils.dateFormat('YYYY-mm-dd HH:MM', new Date(time))
      } else {
        return this.$constants.EMPTY
      }
    },
    onGoTaskDetail(row) {
      this.taskInfo = row
      this.$router.push({
        name: 'rustTaskDetail',
        query: {
          taskId: this.taskInfo.ID
        }
      })
    },
    onPopConfirmRestart(row) {
      this.taskInfo = row
      this.showRestartRustDetectorTask = true
    },
    onRestartTaskSuccess() {
      this.getTaskList()
    }
  }
}
</script>

<style scoped lang="scss">

@import '@/styles/variables/theme';
@import '@/styles/variables/adaptation';
.rust-contract-detail {
  @include adaptation(
    (
      --rust-contract-detail-base-info-height: 312px,
      --rust-contract-detail-task-section-unavailable-height: 88px
    )
  );
  --rust-contract-detail-min-height: var(--base-main-router-body-avaliable-height);
  --rust-contract-detail-task-list-min-height: calc(var(--rust-contract-detail-min-height) - var(--rust-contract-detail-base-info-height) - var(--rust-contract-detail-task-section-unavailable-height));
  min-height: var(--rust-contract-detail-min-height);

  .normal-table-wrap {
    height: 100%;
    min-height: var(--rust-contract-detail-task-list-min-height);

    /deep/ {
      .el-empty {
        height: 100%;
        min-height: var(--rust-contract-detail-task-list-min-height);
      }


      .normal-table {
        height: 100%;
        min-height: var(--rust-contract-detail-task-list-min-height);
      }
    }
  }
}
</style>
